import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Option } from './StyledComponents';

const GuestOptions = ({ guestUserResetPath }) => {
  const { t } = useTranslation('header');

  return (
    <Link
      href={guestUserResetPath}
      id="guestUserConversion"
      data-method="patch"
    >
      <Option>{t('guestButtons.startOver')}</Option>
    </Link>
  );
};

export default GuestOptions;
